import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ModelViewer } from "./model-viewer";

export function App() {
  return (
    <Router>
      <div className="w-full h-full">
        <Routes>
          <Route path="/" element={<Overview />} />
        </Routes>
      </div>
    </Router>
  );
}

function Overview() {
  const id = "KingHenry8_RT_v01_lod1";

  return (
    <div id="overview">
      <ModelViewer
        src={`/assets/${id}.glb`}
        environment-image="https://modelviewer.dev/shared-assets/environments/aircraft_workshop_01_1k.hdr"
        tone-mapping="aces"
        camera-orbit="41.02deg 73.85deg 3.734m"
      ></ModelViewer>
      {
        // <div id="loader"></div>
      }
      <div id="logo-wrapper">
        <div id="logo">
          <img src="/artfabrik.svg" alt="Artfabrik Logo" />
        </div>
      </div>
    </div>
  );
}
